import React from "react";
import styled from "styled-components";
import { FontWeight } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import Evolution from "@ui-kit/format/evolution";
import Tooltip from "@ui-kit/tooltip";

export interface ChartyKpiEvolutionProps {
  evolution: number;
  locale: Locale;
  percentagePoint: boolean;
  tooltip?: React.ReactNode;
}

const StyledEvolution = styled(Evolution)`
  margin-left: 6px;
  font-size: 14px;
  font-weight: ${FontWeight.Normal};
`;

export default function ChartyKpiEvolution({
  evolution,
  locale,
  tooltip,
  percentagePoint,
}: ChartyKpiEvolutionProps) {
  return tooltip ? (
    <Tooltip tooltip={tooltip} placement="top">
      <span>
        <StyledEvolution
          evolution={evolution}
          locale={locale}
          percentagePoint={percentagePoint}
          knowable
        />
      </span>
    </Tooltip>
  ) : (
    <StyledEvolution
      evolution={evolution}
      locale={locale}
      percentagePoint={percentagePoint}
    />
  );
}
